import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LoggedInUserInformationService } from '@ptl/account-management';
import { ContentStorageService } from '@ptl/global-components';
import { CommonUtilityService } from 'src/app/shared/utility-services/common-utility.service';


@Component({
    selector: 'app-conflicting-effective-date-modal',
    templateUrl: './conflicting-effective-date-modal.component.html',
    styleUrls: ['./conflicting-effective-date-modal.component.scss'],
    standalone: false
})
export class ConflictingEffectiveDateModalComponent implements OnInit {

  PRODUCER_KEY = 'producer2023RedirectLink';
  CONSUMER_KEY = 'consumer2023RedirectLink';

  producerLink: string;
  consumerLink: string;

  constructor(
    private dialogRef: MatDialogRef<ConflictingEffectiveDateModalComponent>,
    private loggedInUserService: LoggedInUserInformationService,
    private commonUtilityService: CommonUtilityService,
    private contentStorage: ContentStorageService,
    @Inject(MAT_DIALOG_DATA) public data: {}
  ) { }

  ngOnInit(): void {
    const urlContentMap = this.contentStorage.getContentMap('enrollment') as Map<any, any>;
    this.consumerLink = urlContentMap.get(this.CONSUMER_KEY) ? urlContentMap.get(this.CONSUMER_KEY) : '/view-plans';
    this.producerLink = urlContentMap.get(this.PRODUCER_KEY) ? urlContentMap.get(this.PRODUCER_KEY) : '/medicare/view-plans';
  }

  goToReviewEntries() {
    this.dialogRef.close();
  }

  goToViewPlans() {
    const isProducerFlow = this.commonUtilityService.isAgent();

    if (isProducerFlow) {
      window.location.assign(this.producerLink);
    }
    else {
      window.location.assign(this.consumerLink);
    }
  }

}